export default "The reason is Wisr does not provide financing to business customers.\n";